import numeral from 'numeral';

export default function formattedCurrency(value) {
  return numeral(value).format('0,0.00');
}
